(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/calculator-modal"],{

/***/ "./src/assets/js/calculator-modal.js":
/*!*******************************************!*\
  !*** ./src/assets/js/calculator-modal.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var CalculatorModal = /*#__PURE__*/function (_HTMLElement) {
  function CalculatorModal() {
    var _this;
    _classCallCheck(this, CalculatorModal);
    _this = _callSuper(this, CalculatorModal);
    _this.closeButton = _this.querySelector('.calculator-modal__close');
    _this.overlay = _this.querySelector('.calculator-modal__overlay');
    _this.modalWrapper = _this.querySelector('.calculator-modal-wrapper');
    _this.type = _this.dataset.type ? _this.dataset.type : null;
    _this.body = document.body;
    _this.pageurl = _this.dataset.pageurl;
    _this.innerContent = _this.querySelector('.calculator-modal__inner-content');
    _this.section_id = _this.dataset.sectionid;
    _this.parentSection = document.querySelector("#shopify-section-".concat(_this.section_id));
    _this.isLoaded = false;
    _this.onKeydown = _this.onKeydown.bind(_this);
    return _this;
  }
  _inherits(CalculatorModal, _HTMLElement);
  return _createClass(CalculatorModal, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.init();
      document.addEventListener('keydown', this.onKeydown);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(e) {
      if (e.key === 'Escape') this.closeModal();
    }
  }, {
    key: "clearContent",
    value: function clearContent() {
      this.innerContent.innerHTML = '';
    }
  }, {
    key: "setEventListeners",
    value: function setEventListeners() {
      var _this2 = this;
      this.overlay.onclick = function (event) {
        if (event.target === event.currentTarget) {
          _this2.closeModal();
        }
      };
      this.closeButton.onclick = function () {
        return _this2.closeModal();
      };
    }
  }, {
    key: "pullContentFromUrl",
    value: function pullContentFromUrl(url) {
      var _this3 = this;
      fetch(url).then(function (response) {
        return response.text();
      }).then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var scriptElement = doc.querySelector('.feed-calculator-script');
        if (scriptElement) {
          var scriptTag = document.createElement('script');
          scriptTag.textContent = scriptElement.textContent;
          _this3.innerContent.prepend(scriptTag);
        }
        var calculatorFormElement = doc.querySelector('.feed-calculator__form');
        if (calculatorFormElement) {
          _this3.innerContent.insertAdjacentHTML('beforeend', calculatorFormElement.innerHTML);
        } else {
          console.error('Calculator form (.feed-calculator__form) not found on page:', url);
          console.error('Available content:', doc.body.innerHTML.substring(0, 500));
        }
      })["catch"](function (error) {
        return console.error('Error fetching calculator content:', error);
      });
    }
  }, {
    key: "init",
    value: function init() {
      this.setEventListeners();
    }

    // Method to open the modal
  }, {
    key: "openModal",
    value: function openModal(e) {
      e ? e.preventDefault() : null;

      // Move modal to top level (after main element) to avoid overflow/z-index issues
      var mainEl = document.querySelector('main');
      if (mainEl && this.parentNode !== mainEl.parentNode) {
        if (mainEl.nextSibling) {
          mainEl.parentNode.insertBefore(this, mainEl.nextSibling);
        } else {
          mainEl.parentNode.appendChild(this);
        }
      }
      this.modalWrapper.style.display = "flex";
      this.overlay.style.display = 'block';
      this.body.style.overflow = 'hidden';
      if (!this.isLoaded) {
        this.pullContentFromUrl(this.pageurl);
        this.isLoaded = true;
      }
    }

    // Method to close the modal
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.modalWrapper.style.display = "none";
      this.overlay.style.display = 'none';
      this.body.style.overflow = 'auto';
      if (this.type === 'referral') {
        sessionStorage.setItem('has_closed_popup', 'true');
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Define the new element
customElements.define('calculator-modal', CalculatorModal);

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/calculator-modal.js"));
/******/ }
]);